import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';
import { UpdateMessageTemplateModel } from './UpdateMessageTemplateModel';

@Service()
export default class UpdateMessageTemplateRequestService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async get(id: string) {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/message-template/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async post(model: any) {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/message-template';
            const result = await this.axiosService.axiosInstance.put(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    
    public async ConnectingSenderName(senderName: string, crNumber: string, customerType: number): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/senders/get-sender-for-message-templateRequest-request?'
                +'senderName=' + senderName
                + '&crNumber=' + crNumber
                + '&customerType=' + customerType;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }  
}
